<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="type" placeholder="状态" clearable>
          <el-option label="共赢数据" value="data"></el-option>
          <el-option label="联营管理数据" value="spaceData"></el-option>
          <el-option label="用户查看数据" value="spaceDataU"></el-option>
          <el-option label="商品数据" value="mallData"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="info" @click="getList(1)">搜索</el-button>
      <el-form-item>
        <el-button type="primary" @click="addPage">新增共赢数据</el-button>
        <el-button type="success" @click="addSpace('spaceDataAdd')">新增联营门店数据</el-button>
        <el-button type="success" @click="addSpace('spaceUserData')">新增用户查看数据</el-button>
        <el-button type="success" @click="addMallData">新增商场数据</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #handler="{ row }">
        <el-button type="primary" @click="toDetail(row)">详情</el-button>
      </template>
    </auto-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "key", value: "param_key" },
        { name: "时间", value: "update_time" },
        { name: "说明", value: "handler", type: "custom" },
      ],
      Total: 0,
      type: "data",
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    addSpace(name) {
      this.$router.push({ name });
    },
    addMallData(){
      this.$router.push({ name: "mallData" });
    },
    addPage() {
      this.$router.push({ name: "agentD" });
    },
    toDetail(row) {
      if (row.type == "spaceData") {
        this.$router.push({
          name: "spaceDataAdd",
          query: { id: row.param_key },
        });
      } else if (row.type == "spaceDataU") {
        this.$router.push({
          name: "spaceUserData",
          query: { id: row.param_key },
        });
      } else if (row.type == "mallData") {
        this.$router.push({
          name: "mallData",
          query: { id: row.param_key },
        });
      } else {
        this.$router.push({ name: "agentD", query: { id: row.param_key } });
      }
    },
    //分成记录
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/sysParam/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          type: this.type,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>